import React, { useContext, useEffect } from 'react';
import UserContext from '../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaMapMarkedAlt } from 'react-icons/fa';
import authenticate from './Authenticate';

const UserProfile = () => {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
    }
    startup();
  }, [user, setUser, navigate]);

  if (!user) {
    return <p>Loading...</p>;
  }

  return (
    <div className="bg-gray-100 py-6 flex justify-center mx-4">
      <div className="flex flex-col md:flex-row max-w-4xl w-full space-y-6 md:space-y-0 md:space-x-6">
        {/* User Details Card */}
        <div className="bg-white shadow-md rounded-lg p-6 flex-1 border border-fmb-secondary">
          <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-800 flex items-center">
            <FaUser className="mr-2 text-red-700" />
            User Details
          </h2>
          <div className="mb-4">
            <p className="text-fmb font-semibold">Name</p>
            <p className="font-semibold text-gray-600">{user.name}</p>
          </div>
          <div className="mb-4">
            <p className="text-fmb font-semibold">ITS No</p>
            <p className="font-semibold text-gray-600">{user.its}</p>
          </div>
          <div className="mb-4">
            <p className="text-fmb font-semibold">Role</p>
            <p className="font-semibold text-lime-600">{user.role}</p>
          </div>
        </div>

        {/* Zone Details Card */}
        <div className="bg-white shadow-md rounded-lg p-6 flex-1 border border-fmb-secondary">
          <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-800 flex items-center">
            <FaMapMarkedAlt className="mr-2 text-red-700" />
            Zone Details
          </h2>
          <div className="mb-4">
            <p className="text-fmb font-semibold">Zone</p>
            <p className="font-semibold text-gray-600">{user.zone?.desc}</p>
          </div>
          <div className="mb-4">
            <p className="text-fmb font-semibold">Zone No</p>
            <p className="font-semibold text-gray-600">{user.zone?.id}</p>
          </div>
          <div className="mb-4">
            <p className="text-fmb font-semibold">Address</p>
            <p className="font-semibold text-gray-600">{user.zone?.address}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
